/**
 * Custom Error handler
 */
import { Container, Alert, AlertTitle } from '@mui/material';
import { CenterContent } from './LayoutStyles';

/**
 *
 * @param {object} error
 * @param {Function} setErrorMessage
 */
export function HttpErrorHandler(error, setErrorMessage) {
  let message = '';
  if (error.response) {
    message = error.response.data.message ;
  } else if (error.request) {
    message = 'Si è verificato un errore, riprova più tardi';
  } else {
    message = error.message;
  }
  setErrorMessage(message);
}

/**
 *
 * @param {string} message
 * @returns Error page UI
 */
export function ErrorUI(message) {
  return (
    <Container>
      <CenterContent>
        <Alert variant="filled" severity="error" elevation={6}>
          <AlertTitle>Errore</AlertTitle>
          {message}
        </Alert>
      </CenterContent>
    </Container>
  );
}
